import React, { useCallback, useEffect, useState } from 'react';
import { Wrapper } from './style';

// Components
import Translation from 'libs/Translation';
import { Box } from '@mui/material';
import Timer from 'components/common/Timer';
import Text from 'components/common/Text';
import Button from 'components/common/Button';

// Types
const CountDown = ({ onClick, loading, nextRetry, retryButton, finishTimer, color, contentAfter, contentBefore }) => {
	const [timer, setTimer] = useState(0);
	const [timerFinished, setTimerFinished] = useState(false);

	useEffect(() => {
		const now = new Date();
		const timer = nextRetry - now.getTime();
		setTimer(Math.max(parseInt(timer / 1000), 0));
		setTimerFinished(false);

	}, [nextRetry]);

	const handleFinishTimer = useCallback(() => {
		setTimerFinished(true);
		if (finishTimer) finishTimer();
	}, []);

	const showTimer = Boolean(timer && !timerFinished);

	const handleRetry = () => {
		onClick();
	}

	return ( 
	<>
		{retryButton ?
		<Wrapper>
			<Button 
				onClick={handleRetry} 
				disabled={showTimer || loading}
				loading={loading}
				className="button"
			>
			{showTimer ?
				<Box sx={{ minWidth: 45, display: 'inline-block' }}>
					<Timer initialSeconds={timer} onFinishTimer={handleFinishTimer} /> {' '}
				</Box>
				:
				<Text
					tag="span"
					className="text"
				>
					{Translation.t('label.button.resend')}
				</Text>
			}
			</Button>
		</Wrapper>
		:
		<span>
		{showTimer ?
		<>
			{contentBefore &&
				contentBefore
			}
			{' '}
			<span 
				style={{color: color}}
			>
				<Timer initialSeconds={timer} onFinishTimer={handleFinishTimer} color={color} />
			</span>
			{' '}
			{contentAfter &&
				contentAfter
			}
		</>
		:
		null
		}
		</span>
		}
	</>
	);
};

export default CountDown;